function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip-program-new)"
}, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M17.8387 28.099C21.865 21.3139 27.7145 14.2563 36.1239 9.16652C32.3905 12.6378 26.4059 19.4541 23.4447 24.6411C28.3563 25.0711 35.2314 22.2677 40.0365 18.2162C38.9513 18.0936 33.913 17.1812 32.4058 15.893C35.2957 16.1261 40.1269 16.1844 42.0421 16.0478C45.9389 13.1619 50.3682 6.34914 52 0.287994C17.5983 0.287994 17.4782 20.1404 17.6158 22.7938C16.4442 24.496 15.3905 26.2025 14.4442 27.8807C14.4031 27.9536 14.3623 28.0263 14.3216 28.099H8.03855C6.83615 28.099 5.86141 29.0738 5.86141 30.2762C5.86141 31.0507 6.26582 31.7307 6.87499 32.1166L6.02899 32.2858C2.69898 32.2858 0 34.9868 0 38.3148V46.3535C0 49.6815 2.69898 52.3825 6.02899 52.3825H26.1256C29.4556 52.3825 32.1546 49.6815 32.1546 46.3535V38.3148C32.1546 34.9868 29.4556 32.2858 26.1256 32.2858L25.2794 32.1166C25.8886 31.7307 26.293 31.0506 26.293 30.2762C26.293 29.0738 25.3182 28.099 24.1158 28.099H17.8387Z",
  fill: "#1B1E31"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip-program-new"
}, /*#__PURE__*/React.createElement("rect", {
  width: 52,
  height: 52,
  fill: "white"
})));

var SvgProgramNew = function SvgProgramNew(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 52,
    height: 52,
    viewBox: "0 0 52 52",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgProgramNew, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/ProgramNew.9dd2f986.svg";
export { ForwardRef as ReactComponent };